import React from 'react'

import { Col, Row } from 'antd'

import TaxAdvantage from 'common/components/benefit/Expenses/TaxAdvantageExpense'
import TaxFree from 'common/components/benefit/Expenses/TaxFreeExpense'
import RedAsterisk from 'common/components/dataEntry/components/RedAsterisk'
import Radio from 'common/components/dataEntry/formik/FormikRadioField'

type ExpenseTypeRadioProps = {
  month: string
  yesText: string
  noText: string
  mec: boolean
}

const ExpenseTypeRadio = ({ month, yesText, noText, mec }: ExpenseTypeRadioProps) => {
  return (
    <div>
      <Row gutter={8}>
        <Col span={24}>
          <div className="flex mb-8">
            <RedAsterisk className="mr-4" />
            <span className={'mr-8'}>
              In <b>{month}</b> were you covered by MEC?
              <a
                href={
                  'https://peoplekeephelp.zendesk.com/hc/en-us/articles/360035075914-What-is-minimum-essential-coverage-MEC-'
                }
                target={'_blank'}
                className="ml-8"
                rel="noreferrer"
              >
                Learn more <i className="fal fa-external-link-alt"></i>
              </a>
            </span>
          </div>
        </Col>
      </Row>

      <Radio.Group name="mec" className="w-100 mb-16">
        <Row gutter={16}>
          <Col span={24} className="flex items-center flex__wrap">
            <Row gutter={8}>
              <Col span={24}>
                <Radio value={true}>{yesText}</Radio>
              </Col>
              <Col span={24}>
                <Radio value={false}>{noText}</Radio>
              </Col>
            </Row>

            {mec !== undefined && mec && <TaxFree />}
            {mec !== undefined && !mec && <TaxAdvantage />}
          </Col>
        </Row>
      </Radio.Group>
    </div>
  )
}

export default ExpenseTypeRadio
